import React, { useState, useEffect, useContext } from 'react';
import NormalButton, { INormalButton } from './NormalButton';
import { ThemeContext } from '../../store/ThemeProvider';
import ReactSVG from 'react-svg';
import { uuid, formatCommentNumber } from '../../utils/util';
import { getPendantColor } from '../../utils/color';
import stat from '../../utils/stat';

const GOOD_ICONS = {
  border: require('../../assets/good/good-border.png'),
  icons: [
    require('../../assets/good/good-1.png'),
    require('../../assets/good/good-2.png'),
    require('../../assets/good/good-3.png'),
    require('../../assets/good/good-4.png'),
    require('../../assets/good/good-5.png'),
    require('../../assets/good/good-6.png')
  ]
};

let GOOD_BOOST_TIMER = 0;
let GOOD_POINT_TIMER = 0;

export default (props: INormalButton) => {
  const { backgroundColor, mainColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor, true);

  const [borderId, setBorderId] = useState('');
  const [count, setCount] = useState(0);

  useEffect(() => {
    setBorderId(uuid());

    // 统计这块，肯定是异步的，有时候刷新界面后，看到的还是老数据，所以把自己看到的数据存到本地，取与服务器数据相比中的最大值
    let defaultData = window.gallery.praise || 0;
    let localData = window.localStorage.getItem(`${window.gallery.id}_praise`);

    defaultData = Math.max(Number(localData), defaultData);
    setCount(defaultData);
  }, []);

  const resetBorder = () => {
    clearTimeout(GOOD_BOOST_TIMER);

    setCount(count + 1);
    window.localStorage.setItem(
      `${window.gallery.id}_praise`,
      String(count + 1)
    );

    const random = Math.round(Math.random () * 2) + 1;
    for(let i=0;i<random;i++) {
      stat.count(`praise_trigger`);
    }

    let borderDom = document.getElementById(`border_${borderId}`);
    let pointDom = document.getElementById(`point_${borderId}`);

    if (borderDom) {
      borderDom.className = `border boost`;
      borderDom.style.transform = `rotate(${Math.round(Date.now() / 1000) %
        360}deg)`;

      // @ts-ignore
      GOOD_BOOST_TIMER = setTimeout(() => {
        borderDom && (borderDom.className = 'border');
      }, 300);
    }

    clearTimeout(GOOD_POINT_TIMER);

    if (pointDom) {
      let iconRandom = Math.floor(Math.random() * 6);
      let animationRandom = Math.ceil(Math.random() * 5);

      let img = document.createElement('img');
      img.src = GOOD_ICONS.icons[iconRandom];
      img.className = `ball${animationRandom}`;

      pointDom.appendChild(img);

      // @ts-ignore
      GOOD_POINT_TIMER = setTimeout(() => {
        // 清除掉所有DOM结点
        pointDom && (pointDom.innerHTML = '');
      }, 2800);
    }
  };

  return (
    <div
      className={`pendant-row pendant-good`}
      onClick={() => {
        resetBorder();
      }}
    >
      <div id={`border_${borderId}`} className={`border`}>
        <img src={GOOD_ICONS.border} />
      </div>
      <div
        className="pendent-normal"
        style={{
          color: pendantIconColor,
          backgroundColor: pendantBgColor,
          ...props.style
        }}
      >
        <img src={require('../../assets/icon-good.png')} alt="" />
        {count > 0 ? (
          <div className="good-number">{formatCommentNumber(count)}</div>
        ) : null}
      </div>
      <div id={`point_${borderId}`} className="points"></div>
    </div>
  );
};
